import React, { useState, useEffect, useContext } from 'react'

import DataGrid from 'src/common/components/DataGrid'
// import DeleteIcon from 'src/common/icons/deleteIcon'

import './styles.css'

import { useNavigate } from 'react-router-dom'

import { columns } from './constants'
import companyService from 'src/services/company.service'
import { SnackBarContext } from 'src/App'
import { specialCompanyIds } from 'src/common/nav/Nav'
import { parseJwt } from 'src/heplers'
import { GetReportButton, REPORT_PAGES } from 'src/common/components/GetReportButton'

const Actions = () => {
  return (
    <div className='row row-center'>
      <GetReportButton page={REPORT_PAGES.COMPANIES} />
    </div>
  )
}

export const sendInviteStatuses = {
  notSent: 'notSent',
  loading: 'loading',
  sent: 'sent'
}

const EmptyUsers = () => (
  <>
    <svg width='120' height='120' viewBox='0 0 120 120' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M105 33.75H72.4999C71.6886 33.75 70.8991 33.4868 70.25 33L57.25 23.25C56.6009 22.7632 55.8114 22.5 55.0001 22.5H33.75C33.2575 22.5 32.7699 22.597 32.3149 22.7854C31.86 22.9739 31.4466 23.2501 31.0983 23.5983C30.7501 23.9466 30.4739 24.36 30.2854 24.8149C30.097 25.2699 30 25.7575 30 26.25V37.5H40.0001C40.8114 37.5 41.6009 37.7632 42.25 38.25L55.25 48C55.8991 48.4868 56.6886 48.75 57.4999 48.75H90C90.4925 48.75 90.9801 48.847 91.4351 49.0354C91.89 49.2239 92.3034 49.5001 92.6517 49.8483C92.9999 50.1966 93.2761 50.61 93.4646 51.0649C93.653 51.5199 93.75 52.0075 93.75 52.5V82.5H105.417C105.854 82.5 106.288 82.4138 106.692 82.2463C107.097 82.0788 107.464 81.8333 107.774 81.5237C108.083 81.2142 108.329 80.8467 108.496 80.4423C108.664 80.0379 108.75 79.6044 108.75 79.1667V37.5C108.75 37.0075 108.653 36.5199 108.465 36.0649C108.276 35.61 108 35.1966 107.652 34.8483C107.303 34.5001 106.89 34.2239 106.435 34.0354C105.98 33.847 105.492 33.75 105 33.75Z'
        fill='#E7E7EE'
      />
      <path
        d='M93.75 52.5V94.1667C93.75 95.0507 93.3988 95.8986 92.7737 96.5237C92.1486 97.1488 91.3007 97.5 90.4167 97.5H18.75C17.7554 97.5 16.8016 97.1049 16.0984 96.4017C15.3951 95.6984 15 94.7446 15 93.75V41.25C15 40.2554 15.3951 39.3016 16.0984 38.5984C16.8016 37.8951 17.7554 37.5 18.75 37.5H40C40.8114 37.5 41.6009 37.7632 42.25 38.25L55.25 48C55.8991 48.4868 56.6886 48.75 57.5 48.75H90C90.9946 48.75 91.9484 49.1451 92.6517 49.8484C93.3549 50.5516 93.75 51.5054 93.75 52.5Z'
        stroke='#E7E7EE'
        strokeWidth='5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M30 37.5V26.25C30 25.2554 30.3951 24.3016 31.0984 23.5984C31.8016 22.8951 32.7554 22.5 33.75 22.5H55C55.8114 22.5 56.6009 22.7632 57.25 23.25L70.25 33C70.8991 33.4868 71.6886 33.75 72.5 33.75H105C105.995 33.75 106.948 34.1451 107.652 34.8484C108.355 35.5516 108.75 36.5054 108.75 37.5V79.1667C108.75 79.6044 108.664 80.0379 108.496 80.4423C108.329 80.8467 108.083 81.2142 107.774 81.5237C107.464 81.8332 107.097 82.0787 106.692 82.2463C106.288 82.4138 105.854 82.5 105.417 82.5H93.75'
        stroke='#E7E7EE'
        strokeWidth='5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>

    <p style={{ textAlign: 'center', color: '#76767F' }}>No Companies found</p>
  </>
)

const Companies = () => {
  const navigate = useNavigate()

  const userLocal = JSON.parse(localStorage.getItem('user'))
  const companyId = userLocal ? parseJwt(userLocal?.accessToken)?.companyId : null

  if (!specialCompanyIds.includes(companyId)) {
    navigate('/not-found')
  }
  const defaultFilters = {
    page: 0,
    size: 50
  }

  const [totalCount, setTotalCount] = useState(null)
  const [companies, setCompanies] = useState([])
  const [openDrawer, setOpenDrawer] = useState(false)

  const [filters, setFilters] = useState(defaultFilters)
  const [loading, setLoading] = useState(false)

  const { setErrorMessage } = useContext(SnackBarContext)

  const handleFilter = param => {
    const newParam = param?.status ? { status: param.status.toUpperCase() } : param?.sort ? { sort: param.sort } : param
    setFilters({ ...filters, ...newParam })
  }

  const handleSelect = ids => {
    // setSelectedIds(ids)
    // setIdsToInvite(ids)
  }

  const openElement = id => {
    // setSelectedUserId(id)
    setOpenDrawer(!openDrawer)
  }

  useEffect(() => {
    setLoading(true)
    companyService
      .getClildCompanies(filters)
      .then(resp => {
        setLoading(false)
        setTotalCount(parseInt(resp.headers['x-total-count']))
        setCompanies(resp.data)
      })
      .catch(() => {
        setLoading(false)
        setErrorMessage('Something went wrong')
      })
  }, [filters])

  const usersColumns = columns()

  return (
    <div style={{ padding: '24px' }}>
      <div className='row row-center' style={{ marginBottom: 24 }}>
        <h1 style={{ margin: 0, fontSize: 24 }}>Companies</h1>
      </div>

      <DataGrid
        loading={loading}
        disableSelect={true}
        total={totalCount}
        filters={filters}
        onFilter={handleFilter}
        onOpenElement={openElement}
        actions={<Actions />}
        // selectedIds={selectedIds}
        onSelect={handleSelect}
        rows={companies}
        columns={usersColumns}
        emptyListElement={<EmptyUsers />}
      />
    </div>
  )
}

export default Companies
